var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.$t('basic'),"directory":_vm.$t('datatables'),"icon":'grid'}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('list-view',{staticClass:"mb-primary"}),_vm._v(" "),_c('profile-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }